/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Details_Archive_Reason_FailureInputs */

const fr_vehicle_details_archive_reason_failure = /** @type {(inputs: Vehicle_Details_Archive_Reason_FailureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a subi une casse irrémédiable`)
};

const en_vehicle_details_archive_reason_failure = /** @type {(inputs: Vehicle_Details_Archive_Reason_FailureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`was damaged beyond repair`)
};

/**
* | output |
* | --- |
* | "was damaged beyond repair" |
*
* @param {Vehicle_Details_Archive_Reason_FailureInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_details_archive_reason_failure = /** @type {((inputs?: Vehicle_Details_Archive_Reason_FailureInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Details_Archive_Reason_FailureInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_details_archive_reason_failure(inputs)
	return en_vehicle_details_archive_reason_failure(inputs)
});